<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="24" class="gutter-row">
            <h2>Dashboard</h2>
          </a-col>
        </a-row>
        <template>
          <a-row :gutter="40">
            <a-col
              :xs="{ span : 24 }"
              :md="{ span : 8 }"
              style="margin-bottom: 10px;"
              class="gutter-row"
            >
              <a-card title="Total Users" class="Custom--Card" :loading="loadingTotalUsers">
                <template slot="extra" >
                  <a-select v-model="usersSelected" @change="totalUsers">
                    <a-select-option value="last-30-days">Last 30 Days</a-select-option>
                    <a-select-option value="last-month">Last Month</a-select-option>
                    <a-select-option value="last-7-days">Last 7 Days</a-select-option>
                  </a-select>
                  <a-divider type="vertical" />
                  <a-button type="default" shape="circle" icon="sync" size="small" @click="totalUsers('refresh')"/>
                </template>


                <h1>{{users.count}}</h1>
                <p style="margin-top: 30px;">
                  <a-icon v-if="users.type == 'increase'" type="caret-up"/>
                  <a-icon v-else type="caret-down"/>
                  {{users.percentage.toFixed(2)}}% {{users.type}}
                </p>
              </a-card>
            </a-col>
            <a-col
              :xs="{ span : 24 }"
              :md="{ span : 8 }"
              style="margin-bottom: 10px;"
              class="gutter-row"
            >
              <a-card a-card title="Emails Sent" class="Custom--Card" :loading="loadingEmailsSent">
                <template slot="extra">
                  <a-select v-model="emailsSelected" @change="emailSent">
                    <a-select-option value="last-30-days">Last 30 Days</a-select-option>
                    <a-select-option value="last-month">Last Month</a-select-option>
                    <a-select-option value="last-7-days">Last 7 Days</a-select-option>
                  </a-select>
                  <a-divider type="vertical" />
                  <a-button type="default" shape="circle" icon="sync" size="small" @click="emailSent('refresh')"/>
                </template>
                <h1>{{emails.count}}</h1>
                <p style="margin-top: 30px;">
                  <a-icon v-if="emails.type == 'increase'" type="caret-up"/>
                  <a-icon v-else type="caret-down"/>
                  {{parseInt(emails.percentage).toFixed(2)}}% {{emails.type}}
                </p>
              </a-card>
            </a-col>
            <a-col
              :xs="{ span : 24 }"
              :md="{ span : 8 }"
              style="margin-bottom: 10px;"
              class="gutter-row"
            >
              <a-card a-card title="Subscribers" class="Custom--Card" :loading="loadingSubscribersList">
                <template slot="extra">
                <a-select v-model="subscribersSelected" @change="subScribersList">
                  <a-select-option value="last-30-days">Last 30 Days</a-select-option>
                  <a-select-option value="last-month">Last Month</a-select-option>
                  <a-select-option value="last-7-days">Last 7 Days</a-select-option>
                </a-select>
                  <a-divider type="vertical" />
                  <a-button type="default" shape="circle" icon="sync" size="small" @click="subScribersList('refresh')"/>
                </template>
                <h1>{{subscribers.count}}</h1>
                <p style="margin-top: 30px;">
                  <a-icon v-if="subscribers.type == 'increase'" type="caret-up"/>
                  <a-icon v-else type="caret-down"/>
                  {{subscribers.percentage.toFixed(2)}}% {{subscribers.type}}
                </p>
              </a-card>
            </a-col>
          </a-row>

          <a-row :gutter="40" style="margin-top: 25px;">
            <a-col
                :xs="{ span : 24 }"
                :md="{ span : 16 }"
                class="gutter-row"
                style="margin-bottom: 10px;"
            >
              <NewSites></NewSites>

              <a-card a-card title="New Users" class="Custom--Card" :loading="loadingNewUsers" style="margin-top: 25px;">
                <template slot="extra">
                <a-select v-model="newUsersSelected" @change="newUsersList">
                  <a-select-option value="last-30-days">Last 30 Days</a-select-option>
                  <a-select-option value="last-month">Last Month</a-select-option>
                  <a-select-option value="last-7-days">Last 7 Days</a-select-option>
                </a-select>
                  <a-divider type="vertical" />
                  <a-button type="default" shape="circle" size="small" icon="sync" @click.prevent="newUsersList('refresh')"/>
                </template>
                <!-- Line Chart/Graph here -->
                <template v-if="newUsers">
                  <line-graph :labels="newUsers.labels" :values="newUsers.data" color="red"></line-graph>
                </template>
              </a-card>

            </a-col>
            <a-col
                :xs="{ span : 24 }"
                :md="{ span : 8 }"
                class="gutter-row"
                style="margin-bottom: 10px;"
            >
              <recent-events></recent-events>
            </a-col>
          </a-row>
          <a-row :gutter="40" style="margin-top: 25px;">
            <a-col
                    :xs="{ span : 24 }"
                    :md="{ span : 16 }"
                    class="gutter-row"
                    style="margin-bottom: 10px;"
            >
              <Downloads></Downloads>
            </a-col>
            <a-col
                    :xs="{ span : 24 }"
                    :md="{ span : 8 }"
                    class="gutter-row"
                    style="margin-bottom: 10px;"
            >
              <PluginInfo></PluginInfo>
            </a-col>
          </a-row>
        </template>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import NewSites from "@/components/Dashboard/SitesNewRegistration.vue";
import Downloads from "@/components/Dashboard/Downloads.vue";
import PluginInfo from "@/components/Dashboard/PluginInfo.vue";
import LineGraph from "@/components/LineGraph.vue";
import RecentEvents from "@/components/RecentEvents.vue";
import Sidebar from "@/components/Sidebar.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    LineGraph,
    RecentEvents,
    Sidebar,
    NewSites,
    Downloads,
    PluginInfo
  },
  data() {
    return {
      loading: false,
      loadingTotalUsers: false,
      loadingEmailsSent: false,
      loadingSubscribersList: false,
      loadingNewUsers: false,
      usersSelected: 'last-30-days',
      emailsSelected: 'last-30-days',
      subscribersSelected: 'last-30-days',
      newUsersSelected: 'last-30-days'
    }
  },
  methods: {
    totalUsers(query) {
      this.loadingTotalUsers = true;

      let refresh = false;

      if (query === 'refresh') {
        refresh = true;
      } else {
        this.usersSelected = query;
      }

      this.$store.dispatch("dashboard/getUsers", {query: this.usersSelected, refresh: refresh}).then(() => this.loadingTotalUsers = false );
    },
    emailSent(query) {
      this.loadingEmailsSent = true;

      let refresh = false;

      if (query === 'refresh') {
        refresh = true;
      } else {
        this.emailsSelected = query;
      }

      this.$store.dispatch("dashboard/emailSent", {query: this.emailsSelected, refresh: refresh}).then(() => {
        this.loadingEmailsSent = false;
      });
    },
    subScribersList(query) {
      this.loadingSubscribersList = true;
      let refresh = false;

      if (query === 'refresh') {
        refresh = true;
      } else {
        this.subscribersSelected = query;
      }

      this.$store.dispatch("dashboard/subscribersList", {query: this.subscribersSelected, refresh: refresh}).then(() => this.loadingSubscribersList = false);
    },
    newUsersList(query) {
      this.loadingNewUsers = true;
      let refresh = false;

      if (query === 'refresh') {
        refresh = true;
      } else {
        this.newUsersSelected = query;
      }

      this.$store.dispatch("dashboard/getNewUsers", {query: this.newUsersSelected, refresh: refresh}).then(() => this.loadingNewUsers = false );
    }
  },
  created() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch("dashboard/getUsers", this.usersSelected),
      this.$store.dispatch("dashboard/emailSent", this.emailsSelected),
      this.$store.dispatch("dashboard/subscribersList", this.subscribersSelected),
      this.$store.dispatch("dashboard/getNewUsers", this.newUsersSelected),
    ])
    .then(() =>  this.loading = false);
  },
  computed: {
    ...mapGetters({
      users: "dashboard/getUsers",
      emails: "dashboard/getEmails",
      subscribers: "dashboard/getSubscribers",
      newUsers: "dashboard/getNewUsers",
      user: 'auth/user'
    })
  }
};
</script>

<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  margin: 16px;
  font-size: 1.3em;
  text-align: center;
  color: #fff;
}
</style>